export const resolveLeadConnection = (detailedLead, originalLead, pipelineConnections = []) => {
  const currentLead = detailedLead || originalLead;
  if (currentLead?.connection) return currentLead.connection;

  if (currentLead?.connection_id) {
    const linkedConnection = pipelineConnections.find(
      connection => Number(connection.id) === Number(currentLead.connection_id)
    );
    if (linkedConnection) return linkedConnection;
  }

  return pipelineConnections.find(
    connection => connection.channel === 'whatsapp' && connection.is_active
  ) || null;
};
